import getString from '@/helpers/GetStrings';
import qs from 'qs';

import errorHandler from './errorHandler';

export default {
  mixins: [errorHandler],
  data() {
    return {
      readOnly: false,
    };
  },
  methods: {
    saveChanges(toggleEdit = true) {
      if (toggleEdit && this.readOnly === true) {
        this.readOnly = false;
        return;
      }
      if (this.$v) {
        this.$v.$touch();
        if (this.$v.data && this.$v.data.$anyError) {
          this.$q.notify({
            message: this.getString(null, 'Check all fields and try again', 'Controleer alle velden en probeer opnieuw'),
            type: 'warning',
            timeout: 1200,
            position: 'top-right',
          });
          return;
        }
      }
      let data;
      if (typeof this.requestParams() === 'object') {
        data = qs.stringify(this.requestParams(), { arrayFormat: 'brackets' });
      } else {
        data = this.requestParams();
      }
      const id = this.$route.params && this.$route.params.id ? `/${this.$route.params.id}` : '';
      if (data) {
        this.axios({
          method: this.$route.params.id ? 'PUT' : 'POST',
          url: `/${this.endpoint}${id}`,
          data,
        }).then((res) => {
          const successMessage = this.successMessage || getString(`module.${this.module}.edit.save.success`);
          this.$q.notify({
            message: successMessage,
            type: 'positive',
            timeout: 1200,
            position: 'top-right',
          });

          this.readOnly = true;

          this.$store.dispatch('removeEditorState', this.module);
          // Redirect to detail page of the newly created item
          if (res.headers && res.headers.location) {
            if (this.$route.name === 'FaqQuestionAdd') {
              this.$router.push('/faq');
            } else {
              const location = res.headers.location.split('/').pop();
              this.$router.push(location);
            }
          }
        }).catch((err) => {
          // Handle the error (handleError mixin)
          this.handleError(err);
          console.warn(err);
        });
      } else {
        this.notifyFormError();
      }
    },
  },
};
